export class PagedList<T> {
    items: T[];
    totalPages: number;
    totalCount: number;
}
